<template>
  <div style="width: 100%; height: 100px">
    <div ref="myChart" style="width: 100%; height: 100px"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'TimeChart',
  props: {
    columns: {
      tyoe: Array,
      default: () => []
    },
    dataValue: {
      tyoe: Array,
      default: () => []
    },
    color: {
      tyoe: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null
    }
  },
  computed: {
    chartOption() {
      const categories = []
      const valueData = this.dataValue
      let option = {}
      if (valueData.length) {
        valueData.forEach((res) => {
          categories.push(res.workStation.workStationName)
        })
        const types = []
        this.columns.forEach((res, index) => {
          const data = {
            name: res.collectStatusName,
            color: res.color,
            collectStatus: res.collectStatus
          }
          types.push(data)
        })
        const seriesdata = []
        const time = dayjs().format('YYYY-MM-DD 00:00:00')
        const minTime = dayjs(time).valueOf()
        const maxTime = dayjs(time).valueOf() + 7200000 * 12 - 1
        this.$echarts.util.each(categories, function(category, index) {
          const dataCount = valueData[index].recordItems
          if (dataCount.length > 0) {
            dataCount.forEach((item) => {
              const typeItem = types.find((res) => res.collectStatus == item.iotStatus)
              const baseTime = dayjs(item.startTime).valueOf()
              // 修复不能绘制完成
              const endTime = dayjs(item.endTime).valueOf() - 1
              const duration = endTime - baseTime
              seriesdata.push({
                name: typeItem ? typeItem.name : '未知',
                value: [index, baseTime, endTime, duration],
                itemStyle: {
                  normal: {
                    color: typeItem ? typeItem.color : '#ccc'
                  }
                }
              })
            })
          }
        })
        option = {
          tooltip: {
            formatter: function(params) {
              return (
                params.marker +
                params.name +
                ': ' +
                dayjs(params.value[1]).format('HH:mm:ss') +
                ' ~ ' +
                dayjs(params.value[2]).format('HH:mm:ss')
              )
            }
          },
          title: {
            show: false
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '20',
            top: '10'
            // height: 50
          },
          xAxis: {
            min: minTime,
            max: maxTime,
            type: 'value',
            left: '1%',
            position: 'bottom',
            scale: true,
            interval: 7200000,
            axisLabel: {
              show: true,
              interval: 0,
              formatter: (val) => {
                var strs = dayjs(val)
                  .format('HH:mm')
                  .split('') //字符串数组
                var str = ''
                for (var i = 0, s; (s = strs[i++]); ) {
                  //遍历字符串数组
                  str += s
                  if (!(i % 8)) str += '\n' //按需要求余
                }
                return str
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                type: 'dashed'
              }
            },
            axisTick: {
              show: true
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: {
            data: categories,
            boundaryGap: true,
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          dataZoom: [
            {
              show: false,
              type: 'slider',
              start: 0,
              end: 100,
              width: '70%',
              left: '20%',
              labelFormatter: function(value) {
                return dayjs(value).format('HH:mm')
              }
            }
          ],
          series: [
            {
              type: 'custom',
              renderItem: this.renderItem,
              itemStyle: {
                opacity: 0.8
              },
              encode: {
                x: [1, 2],
                y: 0
              },
              data: seriesdata
            }
          ]
        }
      }
      return option
    }
  },
  watch: {
    chartOption: {
      handler(val, oldVal) {
        this.myChart.setOption(val, true)
        this.myChart.resize()
      },
      deep: true
    }
  },
  mounted() {
    this.myChart = this.$echarts.init(this.$refs.myChart)
    this.myChart.setOption(this.chartOption)
  },
  methods: {
    renderItem(params, api) {
      var categoryIndex = api.value(0)
      var start = api.coord([api.value(1), categoryIndex])
      var end = api.coord([api.value(2), categoryIndex])
      var height = api.size([0, 1])[1] * 1
      var rectShape = this.$echarts.graphic.clipRectByRect(
        {
          x: start[0],
          y: start[1] - height / 2,
          width: end[0] - start[0],
          height: height
        },
        {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height
        }
      )

      return (
        rectShape && {
          type: 'rect',
          shape: rectShape,
          style: api.style()
        }
      )
    }
  }
}
</script>

<style scoped></style>
